export default __webpack_public_path__ + "static/media/dashboard_expand_section_icon.d4fcf695.svg";